import { ResellersFilterFormValues } from "../components";

import { ResellerCommissionStatus } from "./enums";

export * from "./enums";

export const VERIFICATION_FILTER_SEARCH_PARAMETER = "verification";

export const GENDER_FILTER_SEARCH_PARAMETER = "gender";

export const AGE_FROM_FILTER_SEARCH_PARAMETER = "ageFrom";
export const AGE_TO_FILTER_SEARCH_PARAMETER = "ageTo";

export const EARNINGS_FROM_FILTER_SEARCH_PARAMETER = "totalEarningsFrom";
export const EARNINGS_TO_FILTER_SEARCH_PARAMETER = "totalEarningsTo";

export const SALES_FROM_FILTER_SEARCH_PARAMETER = "totalSalesFrom";
export const SALES_TO_FILTER_SEARCH_PARAMETER = "totalSalesTo";

export const CANCELED_FROM_FILTER_SEARCH_PARAMETER =
  "numberOfCanceledOrdersFrom";
export const CANCELED_TO_FILTER_SEARCH_PARAMETER = "numberOfCanceledOrdersTo";

export const DELIVERED_FROM_FILTER_SEARCH_PARAMETER =
  "numberOfDeliveredOrdersFrom";
export const DELIVERED_TO_FILTER_SEARCH_PARAMETER = "numberOfDeliveredOrdersTo";

export const RETURNED_FROM_FILTER_SEARCH_PARAMETER =
  "numberOfReturnedOrdersFrom";
export const RETURNED_TO_FILTER_SEARCH_PARAMETER = "numberOfReturnedOrdersTo";

export const DELETE_STATUS_FILTER_SEARCH_PARAMETER = "deleteStatus";

export const EMPTY_RESELLERS_FILTER_FORM_VALUES: ResellersFilterFormValues = {
  verification: undefined,
  gender: undefined,
  ageFrom: undefined,
  ageTo: undefined,
  totalEarningsFrom: undefined,
  totalEarningsTo: undefined,
  totalSalesFrom: undefined,
  totalSalesTo: undefined,
  numberOfCanceledOrdersFrom: undefined,
  numberOfCanceledOrdersTo: undefined,
  numberOfDeliveredOrdersFrom: undefined,
  numberOfDeliveredOrdersTo: undefined,
  numberOfReturnedOrdersFrom: undefined,
  numberOfReturnedOrdersTo: undefined,
  deleteStatus: undefined
};

export const RESELLER_INFO_ROUTES = [
  { label: "Main Info", path: "mainInfo" },
  { label: "Orders", path: "orders" },
  { label: "Commissions", path: "commissions" },
  { label: "Referrals", path: "referrals" },
  { label: "Shared", path: "shared" },
  { label: "Transactions", path: "transactions" },
  { label: "Recommendations", path: "recommendations" }
];

export const COMMISSION_SOURCE_FILTER_SEARCH_PARAMETER = "source";
export const COMMISSION_STATUS_FILTER_SEARCH_PARAMETER = "commissionStatus";
export const COMMISSION_FROM_FILTER_SEARCH_PARAMETER = "commissionFrom";
export const COMMISSION_TO_FILTER_SEARCH_PARAMETER = "commissionTo";

export const REFERRAL_ID_SEARCH_PARAMETER = "referralId";
export const REFERRALS_ACTIVE_ONLY_SEARCH_PARAMETER = "activeOnly";

/** Colors mirror the order statuses: paid reads as delivered, void as cancelled. */
export const RESELLER_COMMISSION_STATUSES_LIST = [
  {
    label: "Paid",
    value: ResellerCommissionStatus.Paid,
    backgroundColor: "#16C350"
  },
  {
    label: "Pending",
    value: ResellerCommissionStatus.Pending,
    backgroundColor: "#FF9900"
  },
  {
    label: "Void",
    value: ResellerCommissionStatus.Void,
    backgroundColor: "#A8A8BB"
  }
];

/** Client-side CSV export page-walks the endpoint, which is capped at 50 a page. */
export const COMMISSIONS_EXPORT_PAGE_SIZE = 50;
export const COMMISSIONS_EXPORT_MAX_PAGES = 40;

export const RESELLERS_LIST_TABS = [{ label: "All", path: "all" }];
